import React from 'react';
import { Zap, Rocket, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const methods = [{
  title: 'Vía Directa',
  subtitle: 'Fondo de Creadores',
  desc: '10K seguidores en 30 días',
  icon: Zap,
  color: 'text-yellow-400'
}, {
  title: 'Vía Rápida',
  subtitle: 'Marketing de Afiliados',
  desc: 'Hotmart / Amazon',
  icon: Rocket,
  color: 'text-orange-400'
}, {
  title: 'Vía Local',
  subtitle: 'Espacios Publicitarios',
  desc: 'Venta a negocios locales',
  icon: MapPin,
  color: 'text-red-400'
}];
export function PaymentMethods() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-166">
      {methods.map((method, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.2,
      duration: 0.6
    }} className="bg-[#0a1628] border border-[#d4a843]/20 p-8 rounded-xl text-center hover:bg-[#1a2744] transition-colors duration-300 group" data-id="element-167">
          <div className="w-16 h-16 mx-auto bg-[#243352] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-[#d4a843]/10 group-hover:border-[#d4a843]/50" data-id="element-168">
            <method.icon className={`w-8 h-8 ${method.color}`} data-id="element-169" />
          </div>

          <h3 className="text-lg font-bold text-[#d4a843] mb-1 uppercase tracking-wider text-xs" data-id="element-170">
            {method.title}
          </h3>
          <h4 className="text-2xl font-bold text-white mb-3 font-serif" data-id="element-171">
            {method.subtitle}
          </h4>
          <div className="h-0.5 w-12 bg-[#d4a843]/30 mx-auto mb-4" data-id="element-172" />
          <p className="text-gray-300" data-id="element-173">{method.desc}</p>
        </motion.div>)}
    </div>;
}